import { createUseStyles } from 'react-jss';

import { TooltipColors } from './types';

const tooltipColor = (color: TooltipColors, value: string) => ({
  [color]: {
    backgroundColor: `var(${value})`,
    '& .down $arrow': {
      borderTop: `8px solid var(${value})`,
    },
    '& .up $arrow': {
      borderBottom: `8px solid var(${value})`,
    },
  },
});

export default createUseStyles(
  {
    root: {
      borderRadius: 8,
      color: 'var(--x-bg-1)',
      display: 'inline-block',
      lineHeight: '20px',
      fontSize: 14,
      fontWeight: 500,
      padding: [8, 16],
      position: 'relative',
    },

    arrowContainer: {
      position: 'absolute',
      right: 0,
      textAlign: 'center',
      width: '100%',

      '&.up': {
        top: -6,
      },
      '&.down': {
        bottom: -6,
      },
    },

    arrow: {
      margin: '0 auto',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
    },

    ...tooltipColor(TooltipColors.black, '--x-text-color-1'),
    ...tooltipColor(TooltipColors.magenta, '--x-accent-1-1'),
  },
  { name: 'Tooltip' },
);
